import React from 'react'
import AnimateOnScroll from '../components/ScrollAnimations/AnimateOnScroll'
import Button2 from '../components/Buttons/Button2/Button2'
// import AboutCompImage from '../assets/images/bootcamp-image-1.jpg';
import AboutCompImage from '../assets/images/java-bootcamp.webp';
import { Link } from 'react-router-dom';


// const words = ["App Developer", "Web Developer", "API Developer"]; // Fixed typo from "Desinger"


const events = [
    {
        name: 'Java API Bootcamp',
        title: 'Vaajith Rahman',
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vehicula sapien eu nisi commodo, nec fermentum lectus sagittis.',
        image: AboutCompImage, // Replace with real image path
    },
    {
        name: 'React.js Bootcamp',
        title: 'Vaajith Rahman',
        description:
            'Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Ut sit amet vehicula ex.',
        image: AboutCompImage, // Replace with real image path
    },
];


const Events = () => {
    // const [currentIndex, setCurrentIndex] = useState(0);
    // const [fade, setFade] = useState(true);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setFade(false);
    //         setTimeout(() => {
    //             setCurrentIndex((prevIndex) => (prevIndex + 1) % words.length);
    //             setFade(true);
    //         }, 500); // duration of fade-out
    //     }, 3000); // total interval time

    //     return () => clearInterval(interval);
    // }, []);




    const handleReplace = (name) => {
        const replaced = name.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-');
        return replaced;
    };

    return (
        <>
            <div className="events container">
                <AnimateOnScroll>
                    <p className="base_heading_2">
                        How about learning some new stuffs?
                    </p>
                    {/* <p className="base_heading_2" id="words" style={{ opacity: fade ? 1 : 0, transition: 'opacity 0.5s ease-in-out' }}>{words[currentIndex]}</p> */}
                    <p className="base_p_tag">
                        More than aesthetics. We build high-converting websites that speak to your audience and drive real business growth.
                    </p>
                </AnimateOnScroll>

                <AnimateOnScroll>
                    <Button2 text="Explore Our Services" link="/services" />
                </AnimateOnScroll>

            </div>
            <div className="team-grid">
                {events.map((member, index) => (
                    <div className={(index % 2) === 1 ? "team-card rtl" : "team-card"} key={index}>
                        <div className="team-image-wrapper">
                            <img src={member.image} alt={member.name} className="team-image" />
                        </div>
                        <div className="team-content">
                            <h3 className="team-name">{member.name}</h3>
                            <p className="team-role">{member.title}</p>
                            <p className="team-description">{member.description}</p>
                            <Link to={"/event/" + handleReplace(member.name)} className="event-button"> Register Now </Link>

                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default Events